// config.js，可以根据个人需求进行设置以下选项
export default {
    canClickModalHide: false,         //控制是否点击遮罩层关闭
    closeButtonVisible: true,         //控制关闭按钮是否可见，若设置为false则canClickModalHide必定为true
    modalOpacity: 0.5,                //控制遮罩层的透明度（0-1之间的number类型）
    controlButtonVisible: true,       //控制按钮是否可见
}


// WEBPACK FOOTER //
// ./src/util/vue-imageViewer-master/config.js